import React from "react"
import BlockWrapper from "../technical/BlockWrapper"
import HeadlineEnhanced from "../molecules/HeadlineEnhanced"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"

import { ArrowLeft16, ArrowRight16 } from "@carbon/icons-react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

// import Swiper core and required modules
import { Navigation, Pagination, A11y, Scrollbar } from "swiper/modules"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

const ProductPromoSliderBlock = ({ block }) => {
  return (
    <BlockWrapper
      className="bg-gray-50"
      block={block}
      showHeadline="false"
      blockPadding="py-8 md:py-16"
    >
      <div className="flex flex-row flex-wrap -mx-grid">
        <div className="w-full mb-8 md:w-1/2 lg:w-2/5 px-grid md:mb-0">
          <HeadlineEnhanced
            kicker={block.kicker}
            headline={block.headline}
            headlineLevel={block.headline_level}
            subheadline={block.subheadline}
          />
          <div className={block.headline?.length > 0 ? "pt-8" : ""}>
            <Richtext text={block.text} />
          </div>
        </div>
        <div className="w-full md:w-1/2 lg:w-3/5 px-grid">
          <Swiper
            modules={[Navigation, Pagination, A11y, Scrollbar]}
            spaceBetween={32} // 0 vs 32px
            slidesPerView={1} // auto vs {1}
            slidesPerGroup={1}
            rewind={true}
            navigation={{
              disabledClass: "pointer-events-none",
              nextEl: ".swiper-button-next-" + block._uid,
              prevEl: ".swiper-button-prev-" + block._uid,
            }}
            scrollbar={{
              el: `#slider-wrapper-swiper-scrollbar-${block._uid}`,
              draggable: true,
              dragSize: "auto",
              dragClass: "h-full bg-primary rounded-full",
            }}
            breakpoints={{
              //   640: {
              //     slidesPerView: 2,
              //     slidesPerGroup: 1,
              //   },
              //   // 768: {
              //   //   slidesPerView: 2,
              //   //   slidesPerGroup: 2,
              //   // },
              1024: {
                slidesPerView: 2,
                slidesPerGroup: 1,
              },
            }}
          >
            {block.promo_items?.length > 0 &&
              block.promo_items.map((item, index) => (
                <SwiperSlide key={index} className="flex !h-auto mb-4">
                  {item.image?.filename?.length > 0 && (
                    <Link
                      className="relative block bg-white group"
                      link={item.link}
                    >
                      <Image
                        className="block w-full h-full"
                        image={item.image}
                        fitIn={true}
                        forceLoad={true}
                        aspectRatio="3by4"
                      />
                      {item.headline?.length > 0 && (
                        <div className="absolute inset-x-0 bottom-0 px-4 py-4 font-bold transition-opacity duration-500 bg-gradient-to-t from-gray-200 lg:opacity-0 lg:group-hover:opacity-100">
                          {item.headline}
                        </div>
                      )}
                    </Link>
                  )}
                </SwiperSlide>
              ))}
          </Swiper>
          <div className="flex -mx-grid">
            <div className="py-5 px-grid">
              <div
                id={`slider-wrapper-swiper-scrollbar-${block._uid}`}
                // className="relative touch-none bg-gray-200 h-1.5 inset-x-0 cursor-pointer mt-8"
                //className="px-0 bg-gray-200 rounded-full flex flex-row w-[12.5rem]"
                className="w-[12.5rem] h-2 bg-gray-200 rounded-full touch-none cursor-pointer"
              ></div>
            </div>
            <button
              className={`swiper-button-prev-${block._uid} p-2 hover:text-primary `}
            >
              <ArrowLeft16 className="w-8 h-8" />
            </button>
            <button
              className={`swiper-button-next-${block._uid} ml-2 p-2 hover:text-primary `}
            >
              <ArrowRight16 className="w-8 h-8" />
            </button>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default ProductPromoSliderBlock
